(() => {
  'use strict';
  const routes = window.UNJHA_ROUTES || {root: '/', cart: '/cart', currency: 'CAD'};
  const money = cents => new Intl.NumberFormat('en-CA', {style: 'currency', currency: 'CAD'}).format(cents / 100);
  const safeCount = cart => (cart.items || []).reduce((total, item) => total + Math.min(20, item.quantity), 0);
  const count = cart => document.querySelectorAll('[data-bag-count]').forEach(el => { el.textContent = safeCount(cart); });
  const normalizeAndCount = async cart => {
    const updates = {};
    (cart.items || []).forEach(item => { if (item.quantity > 20) updates[item.key] = 20; });
    if (!Object.keys(updates).length) { count(cart); return; }
    try {
      const response = await fetch(routes.root + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({updates})});
      count(response.ok ? await response.json() : cart);
    } catch { count(cart); }
  };
  async function refresh() {
    try {
      const response = await fetch(routes.root + 'cart.js', {headers: {Accept: 'application/json'}});
      if (response.ok) {
        const cart = await response.json();
        await normalizeAndCount(cart);
      }
    } catch { /* Keep server-rendered bag count if the connection is unavailable. */ }
  }
  window.addEventListener('pageshow', refresh);
  document.addEventListener('unjha:cart', event => normalizeAndCount(event.detail));
  const cartForm = document.querySelector('[data-unjha-cart]');
  if (!cartForm) return;
  let toastTimer;
  const showCartMessage = (status, message, isError = false) => {
    if (!status) return;
    window.clearTimeout(toastTimer);
    status.textContent = message;
    status.classList.toggle('is-error', isError);
    status.classList.add('is-visible');
    toastTimer = window.setTimeout(() => {
      status.classList.remove('is-visible', 'is-error');
      status.textContent = '';
    }, 3000);
  };
  async function updateCart(updates, status) {
    cartForm.querySelectorAll('button, input').forEach(el => { el.disabled = true; });
    try {
      const response = await fetch(routes.root + 'cart/update.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({updates})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to update your bag.');
      count(result);
      if (!result.item_count) { location.reload(); return; }
      result.items.forEach(item => {
        const line = cartForm.querySelector(`[data-cart-line="${CSS.escape(item.key)}"]`);
        if (!line) return;
        const input = line.querySelector('[data-line-key]');
        const price = line.querySelector('[data-line-price]');
        if (input) input.value = item.quantity;
        if (price) price.textContent = money(item.final_line_price);
      });
      const subtotal = cartForm.querySelector('[data-cart-subtotal]');
      const lineItemsTotal = (result.items || []).reduce((total, item) => total + Number(item.final_line_price || 0), 0);
      if (subtotal) subtotal.textContent = money(lineItemsTotal) + ' CAD';
      showCartMessage(status, 'Bag updated.');
    } catch (error) {
      showCartMessage(status, error.message || 'Connection interrupted. Please try again.', true);
    } finally {
      cartForm.querySelectorAll('button, input').forEach(el => { el.disabled = false; });
    }
  }
  cartForm.addEventListener('submit', async event => {
    if (event.submitter?.name === 'checkout') return;
    event.preventDefault();
    const status = document.querySelector('[data-cart-message]');
    const updates = {};
    cartForm.querySelectorAll('[data-line-key]').forEach(input => { input.value = Math.min(20, Math.max(0, Number(input.value) || 0)); updates[input.dataset.lineKey] = Number(input.value); });
    updateCart(updates, status);
  });
  cartForm.addEventListener('change', event => {
    const input = event.target.closest('[data-line-key]');
    if (!input) return;
    const status = document.querySelector('[data-cart-message]');
    input.value = Math.min(20, Math.max(0, Number(input.value) || 0));
    updateCart({[input.dataset.lineKey]: Number(input.value)}, status);
  });
  cartForm.addEventListener('click', async event => {
    const remove = event.target.closest('[data-remove-line]');
    if (!remove) return;
    event.preventDefault();
    const status = document.querySelector('[data-cart-message]');
    updateCart({[remove.dataset.removeLine]: 0}, status).then(() => location.reload());
  });
})();
